//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { CreateEditInitParams } from '../common/create-edit-popup/create-edit-popup.controller'

import { CommonHelper } from "../../helpers/common-helper"
import { DataProvider } from "../../helpers/data-provider"
import { IUserSession } from "../../helpers/user-session"
import { LocalizationHelper } from "../../helpers/localization-helper"

import { Enums } from "../../models/common/enums"
import { IReferenceType, IOpObject, IOpData } from '../../models/util/interfaces'
import { OpPackage } from "../../models/core/op-package"
import { OpPackageData } from "../../models/core/op-package-data"

import { ToastHelper, ConvertHelper } from "../../helpers";
import { DetailsOptions } from "../../services/system";

export class PackagesHelper {


    // Consts

    public static get FILE_NAME_PREFIX(): string { return 'packages' }
    public static get REFERENCE_TYPE(): Enums.ReferenceType { return Enums.ReferenceType.IdPackage }
    public static get SIMAX_MODULE_NAME(): Enums.SimaxModuleName { return Enums.SimaxModuleName.Package }

    // Consts End


    // Methods    
    public static deletePackage(dataProvider: DataProvider, packageToDelete: OpPackage): JQueryPromise<OpPackage> {
        const deferred: JQueryDeferred<OpPackage> = $.Deferred<OpPackage>()

        dataProvider.Package
            .deletePackage(packageToDelete)
            .then((savedObject: OpPackage) => {
                deferred.resolve(savedObject)
                ToastHelper.showInfo(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETED, this.SIMAX_MODULE_NAME))
            })
            .fail((error: any) => {
                let errorMsg: string = ConvertHelper.getRequestErrorMessage(error)

                ToastHelper.showError(errorMsg)

                deferred.reject(errorMsg)
            })

        return deferred.promise()
    }

    public static savePackage(dataProvider: DataProvider, packageToSave: OpPackage): JQueryPromise<OpPackage> {
        const deferred: JQueryDeferred<OpPackage> = $.Deferred<OpPackage>()

        dataProvider.Package
            .savePackage(packageToSave)
            .then((savedObject: OpPackage) => {
                CommonHelper.setValueToLocalStorage(CommonHelper.localStorageVarForSavedEntity.packageSaved, true, 0)
                deferred.resolve(savedObject)
                ToastHelper.showInfo(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.SIMAX_MODULE_NAME))
            })
            .fail((error: any) => {
                let errorMsg: string = ConvertHelper.getRequestErrorMessage(error)

                ToastHelper.showError(errorMsg)

                deferred.reject(errorMsg)
            })

        return deferred.promise()
    }

    // Methods End


    // Options

    public static getCreateEditOptions(userSession: IUserSession, referenceObjectId: number = 0, referenceObject: IReferenceType & IOpObject = null): CreateEditInitParams {
        return {
            createEditSelectedTabType: Enums.SimaxCreateEditSelectedTabType.BaseParameters,
            groupReferenceType: Enums.ReferenceType.IdDistributor,
            groupReferenceValue: userSession.getLoggedOperator().idDistributor,
            idReferenceType: PackagesHelper.REFERENCE_TYPE,
            moduleName: PackagesHelper.SIMAX_MODULE_NAME,
            sections: null,
            useBusinessObjects: true,
            referenceObjectRequest: referenceObjectId > 0 ? () => userSession.getDataProvider().Package.getPackage(referenceObjectId) : null,

            referenceObject,
            referenceObjectId,
        }
    }

    public static createOpPackageTypeFromIOpObject(sourceIOpObject: IOpObject, sourcePackage: OpPackage = null): OpPackage {
        if (sourceIOpObject == null) {
            return
        }

        const tempPackage: OpPackage = new OpPackage(null)

        tempPackage.idPackage = sourceIOpObject.idObject
        tempPackage.opState = sourceIOpObject.opState
        tempPackage.idPackageStatus = Enums.PackageStatus.NewOrder

        if (tempPackage.idPackage === 0) {
            tempPackage.creationDate = new Date()
        }
        else {
            if (sourcePackage != null) {
                tempPackage.creationDate = sourcePackage.creationDate
            }
        }

        tempPackage.dataList.push(...sourceIOpObject.dataList.toArray().map((data: IOpData) => OpPackageData.fromIOpData(data)))

        return tempPackage
    }

    public static mapPackageToDelete(sourceObject: OpPackage): OpPackage {
        const packageModel: OpPackage = new OpPackage(null)

        packageModel.opState = Enums.OpChangeState.Modified
        packageModel.dataList.setValue(Enums.PackageStatus.Removed, Enums.DataType.HELPER_ID_PACKAGE_STATUS)
        packageModel.idPackage = sourceObject.idPackage
        packageModel.idPackageStatus = Enums.PackageStatus.Removed
        packageModel.creationDate = sourceObject.creationDate
        packageModel.idDistributor = sourceObject.idDistributor
        packageModel.idOperatorCreator = sourceObject.idOperatorCreator
        packageModel.idOperatorReceiver = sourceObject.idOperatorReceiver

        return packageModel
    }

    public static getDetailsOptions(referenceType: Enums.ReferenceType, selectedItemId: number, pageItemsIds: number[] = []): DetailsOptions {
        return {
            hasPermission: true,
            idReferenceType: referenceType,
            moduleName: Enums.SimaxModuleName.Package,
            pageItemsIds: pageItemsIds,
            referenceObjectId: selectedItemId,
        } as DetailsOptions
    }

    // Options End
}